import { Skeleton } from "@/shared/ui";

export default function CardSkeleton() {
  return (
    <div className="flex flex-col radius-lg border surface-base-stroke surface-base-fill overflow-hidden">
      <Skeleton height={160} width="100%" />
      <div className="p-4 flex flex-col gap-2">
        <Skeleton height={20} width="75%" />
        <Skeleton height={14} width={120} />
        <Skeleton height={14} width={100} />
      </div>
    </div>
  );
}
